import { Component } from "react";

import { BTPopover } from "@btnet/core-components";

import { TextWrap } from "commonComponents/utilities/TextWrap/TextWrap";

/**
 * Shape of the RecentItemsTooltip payload as it arrives from the API. Fields are optional and
 * nullable to match the orval-generated `RecentItemsTooltip` model that callers pass in.
 */
export interface IRecentItemsTooltipData {
    entityName?: string | null;
    recentItems?: IRecentItemData[] | null;
    /** Absent for entities the builder-wide numbering setting does not cover. */
    isBuilderWideNumbering?: boolean | null;
}

interface IRecentItemData {
    customId?: string | null;
    title?: string | null;
}

export class RecentItemsTooltipConfig {
    constructor(data: IRecentItemsTooltipData) {
        this.entityName = data.entityName ?? "";
        this.recentItems = (data.recentItems ?? []).map((r) => new RecentItem(r));
        this.isBuilderWideNumbering = data.isBuilderWideNumbering ?? false;
    }
    entityName: string;
    recentItems: RecentItem[];
    /**
     * True when the builder's "Continuous ID / number across all jobs" setting is on for this
     * entity. Entities the setting does not cover omit it and keep the per-job wording.
     */
    isBuilderWideNumbering: boolean;
}

export class RecentItem {
    constructor(data: IRecentItemData) {
        this.customId = data.customId ?? "";
        this.title = data.title ?? "";
    }
    customId: string;
    title: string;
}

interface IRecentItemsTooltip {
    config: RecentItemsTooltipConfig;
    trigger?: "hover" | "click";
    placement?: "top" | "bottom" | "left" | "right";
}

export class RecentItemsTooltip extends Component<IRecentItemsTooltip> {
    private formatItem = (r: RecentItem) => {
        return `${r.customId}${r.title && r.title !== "" ? ` - ${r.title}` : ""}`;
    };

    render() {
        const { config, trigger, placement = "right" } = this.props;
        return (
            <BTPopover
                content={
                    <TextWrap>
                        <div style={{ marginBottom: 8 }}>
                            When {config.entityName} number is left blank, it&apos;s auto-assigned
                            based on previous numbers used{" "}
                            {config.isBuilderWideNumbering ? "across all jobs" : "per job"}.
                        </div>
                        {config.recentItems && config.recentItems.length > 0 && (
                            <>
                                <div style={{ marginBottom: 8 }}>Recently Added:</div>
                                {config.recentItems.map((recentItem) => (
                                    <div key={recentItem.customId}>
                                        {this.formatItem(recentItem)}
                                    </div>
                                ))}
                            </>
                        )}
                    </TextWrap>
                }
                trigger={trigger}
                placement={placement}
            />
        );
    }
}
